import { Navigate } from "react-router-dom";

const RoleProtectedRoute = ({ children, allowedRoles }) => {
    const userRole = localStorage.getItem("rol") || "Operador";

    if (allowedRoles && !allowedRoles.includes(userRole)) {
        // Redirect to download app page if role is not allowed
        return <Navigate to="/download/app" replace />;
    }

    return children;
};

export default RoleProtectedRoute;
